import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import BlogPage from './BlogPage';
import BlogHome from './BlogHome';
import firebase from '../helpers/firebase';
import { Helmet } from 'react-helmet';

export default class Blog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      posts: {},
    };
  }

  async componentDidMount(): void {
    const blogCollection = await firebase.firestore().collection('blog').get();
    let posts = {};
    blogCollection.docs.forEach((doc) => {
      posts[doc.id] = doc.data();
    });
    this.setState({ posts: posts });
  }

  render() {
    return (
      <div>
        <Helmet>
          <meta
            name="description"
            content="The DeWaste Blog is the place to see content regarding new locations that you’ll find DeWaste at, new products that we launch, and so much more!"
          />

          <meta
            itemProp="name"
            content="DeWaste | Food Waste Analysis for all dining institutions"
          />
          <meta
            itemProp="description"
            content="The DeWaste Blog is the place to see content regarding new locations that you’ll find DeWaste at, new products that we launch, and so much more!"
          />
          <meta itemProp="image" content="https://de-waste.com/logo.png" />

          <meta property="og:image" content="https://de-waste.com/logo.png" />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="DeWaste" />
          <meta
            property="og:description"
            content="The DeWaste Blog is the place to see content regarding new locations that you’ll find DeWaste at, new products that we launch, and so much more!"
          />
          <meta property="og:site_name" content="DeWaste" />
          <meta property="og:url" content="https://de-waste.com/logo.png" />

          <meta name="twitter:card" content="summary" />
          <meta name="twitter:image" content="https://de-waste.com/logo.png" />
          <meta name="twitter:title" content="DeWaste" />
          <meta
            name="twitter:description"
            content="The DeWaste Blog is the place to see content regarding new locations that you’ll find DeWaste at, new products that we launch, and so much more!"
          />
        </Helmet>

        <Switch>
          <Route path="/blog" exact render={(props) => <BlogHome />} />
          {Object.keys(this.state.posts).map((post) => {
            let path = '/blog/' + post;
            return (
              <Route
                path={path}
                key={path}
                exact
                render={(props) => <BlogPage />}
              />
            );
          })}
        </Switch>
      </div>
    );
  }
}
